import { StatusCodes } from "http-status-codes";
import { request } from "../api";
import { headers } from "../../../config/config";
import { MESSAGE } from "../../../constants/api/message";
import { AUTHORIZATION } from "../../../constants/api/auth";
import { Params } from "../../../types/api/api.types";

const { post, get, patch, put } = request;
const { Authorization, Bearer } = AUTHORIZATION;

export const findMemberEmail = async (email: string) => {
	try {
		const endpoint = `find-member-email/${email}`;
		const response = await get(endpoint);

		if (response) {
			const {
				data: { message }
			} = response;
			if (message === "Email doesnot exists!") {
				const {
					data: { result }
				} = response;
				// console.log("Response", response);
				return result;
			}
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;
			alert(message);
		} else if (error.response.status === StatusCodes.UNAUTHORIZED) {
			const { message } = error.response.data;
			alert(message);
		} else {
			throw error;
		}
	}
};

export const findMemberSSN = async (findSSNQuery: string) => {
	try {
		const endpoint = "find-member-ssn";
		const response = await get(endpoint, {}, findSSNQuery as unknown as Params);

		if (response) {
			const {
				data: { message }
			} = response;
			if (message === "SSN doesnot exists!") {
				const {
					data: { result }
				} = response;
				return result;
			} else if (message === "SSN already exists!") {
				const {
					data: { result }
				} = response;
				alert("SSN already exists!");
				return result;
			}
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			alert(message);
		} else if (error.response.status === StatusCodes.UNAUTHORIZED) {
			const { message } = error.response.data;

			alert(message);
		} else {
			throw error;
		}
	}
};
